import React from 'react';

// ✅ Define the type just above the context
export interface AppConfigType {
  featureFlags: {
    disableTableSort: boolean;
  };
  config: {
    baseUrl: string;
    baseAppUrl: string;
    baseDeviceUrl: string;
    baseStorageUrl: string;
    token: string;
    tenantId: string;
    language: string;
    configBrand: string;
    productCode: string;
    appRegionId: string;
    requireManagementId: boolean;
  };
  setConfig: (config: any) => void;
  userProfile: {
    email: string;
    emailVerified: string;
    lastname: string;
    firstname: string;
    username: string;
    id: string;
    locale: string;
    role: string;
  } ;
  userLegal: {
    licenseAccept: boolean;
    legalApps: any[];
  };
  availableFeatures: string[];
  setUserLegal: (userLegal: any) => void;
  setUserProfile: (userProfile: any) => void;
  updateUserLocale: (locale: string) => void;
  setAvailableFeatures: (features: string[]) => void;
  applicationFeatures: any[];
  setApplicationFeatures: (features: any[]) => void;
  subscribedApps: string[];
  setSubscribedApps: (apps: string[]) => void;
  allApps: any[];
  setAllAps: (apps: any[]) => void;
  userAccessApps: any[];
  setUserAccessApps: (apps: any[]) => void;
  availableApps: any[];
  setAvailableApps: (apps: any[]) => void;
}

// ✅ Now use the type in your context definition
export const AppConfig = React.createContext<AppConfigType | undefined>(undefined);
